type Measure = { name: string; duration: number; startTime: number };

class PerformanceTracker {
  private marks = new Map<string, number>();
  private measures: Measure[] = [];

  mark(name: string) {
    this.marks.set(name, performance.now());
  }

  measure(name: string, startMark: string, endMark?: string) {
    const start = this.marks.get(startMark) ?? performance.now();
    const end = endMark ? (this.marks.get(endMark) ?? performance.now()) : performance.now();
    const duration = end - start;
    this.measures.push({ name, duration, startTime: start });
    return duration;
  }

  getMeasures() {
    return [...this.measures];
  }

  flush(handler: (batch: Measure[]) => Promise<any> | void) {
    const batch = [...this.measures];
    this.measures = [];
    return handler(batch);
  }
}

export const performanceTracker = new PerformanceTracker();

export default performanceTracker;


